// removed by extract-text-webpack-plugin
module.exports = {"destination":"_372uW-destination","destination_icon":"_1Vqiy-destination_icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/DestinationInput/DestinationInput.scss
// module id = 809
// module chunks = 0